<template>
  <div class="storeadd" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据提交中..." element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>
    <ul class="lsls first">

      <li>
        <span>仓库名称</span>
        <input type="text" v-model="title" placeholder="请填写仓库名称"/>
      </li>
      <li>
        <span>仓库地址</span>
        <input type="text" v-model="address" placeholder="请输入仓库地址"/>
      </li>
      <li>
        <span>仓库介绍</span>
        <textarea v-model="content" placeholder="请输入仓库介绍"></textarea>
      </li>
    </ul>
    <ul class="lsls">
      <li @click="getQqueystore">
        <span>仓库介绍图<i style="font-size:12px;color:#666;font-style: normal">（建议请上传 640 × 480 格式图片）</i></span>
        <img class="icon" src="~assets/images/icon5.png" />
        <img class="imgs" v-if="img != ''" :src="baseUrl+img" />
      </li>
    </ul>

    <button class="addAddress" @click="saveStore2">立即申请</button>
    <div style="height:30px"></div>


  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        title:'',
        address:'',
        content:'',
        img:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      var pro_id = this.$route.query.pro_id;
      this.pro_id = pro_id
      if(pro_id > 0){
        this.getpro();
      }
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.proCate();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      saveStore2:function(){
        var that = this;
        var number = that.$route.query.id;
        if(that.title == ''){
          that.$alert('请填写仓库名称!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.address == ''){
          that.$alert('请输入仓库地址!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.content == ''){
          that.$alert('请输入仓库介绍!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.img == ''){
          that.$alert('请选择仓库介绍图!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/store/saveStore',
          params:{
            title:that.title,
            address:that.address,
            content:that.content,
            img:that.img,
            user_id:that.userData.id,
            number:number
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data;
          if(res.status == 200){
            that.$router.go(-1)
          }else{
            that.$alert(res.message, '提示', {
              confirmButtonText: '确定'
            });
          }
          
        }).catch(err=>{
          that.fullscreenLoading = false;
            console.log('请求失败:'+err);
        });
        return false;
      },

      getQqueystore:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'chooseImage',
              'getLocalImgData'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['chooseImage'],
              success: function (res) {
                wx.chooseImage({
                  count: 1,
                  sizeType: ['compressed'],
                  sourceType: ['album', 'camera'], 
                  success: function(res) {
                      that.fullscreenLoading = true;
                      var localId = res.localIds[0].toString();
                      wx.getLocalImgData({
                          localId: localId, // 图片的localID
                          success: function(res) {
                            var u = navigator.userAgent;
                            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                            var s = res.localData;
                            if(isAndroid){
                              s = 'data:image/jpg;base64,'+res.localData
                            }
                            that.getAjax(s)
                          }
                      });
                  }
                })
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getAjax:function(localData){
        var that = this;
        $.ajax({
          url:this.$host+'home/product/upload',
          method: 'post',
          data:{
            localData:localData
          },
          success:function(msg){
            if(msg.status == 200){
              that.img = msg.data;
            }else{
              alert('上传失败');
            }
            that.fullscreenLoading = false;
          }
        })
      },

    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .storeadd{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }
  .storeadd ul.lsls{
    display:block;
    width:93%;
    background:#fff;
    margin:0 auto;
    margin-bottom:50px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .storeadd ul.first{
    margin-bottom:15px;
  }
  .storeadd ul.lsls li{
    width:92%;
    margin:0 auto;
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0;
    position: relative;
  }
  .storeadd ul.lsls li font{
    position:absolute;
    right:15px;
    bottom:15px;
    font-size:16px;
    color:#FF751A
  }
  .storeadd ul.lsls li .icon{
    position:absolute;
    right:10px;
    top:20px;
    width:8px
  }
  .storeadd ul li:first-child h2{
    font-size:18px
  }
  .storeadd li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .storeadd ul li span{
    display:block;
    width:100%;
    font-size:16px;
    padding-bottom:15px
  }
  .storeadd ul li input{
    display:block;
    width:100%;
    background:none;
    border:none;
    outline:none;
    font-size:16px;
    margin-top:1px;
  }
  .storeadd ul li .imgs{
    width:31%;
    margin-right:2%
  }
  .storeadd ul li .checkbox{
    float:right;
    width:auto !important;
    margin-right:30px;
    margin-top:4px
  }
  .storeadd ul li textarea{
    float:left;
    width:100%;
    height:80px;
    background:none;
    border:none;
    outline:none;
    font-size:15px;
    resize: none;
  }
  .storeadd .addAddress{
    display:block;
    margin:0 auto;
    width:80%;
    height:45px;
    border:none;
    background:#2F78FF;
    color:#fff;
    font-size:16px;
    border-radius:45px;
  }

</style>